import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceRemoveOrganizationalUnitState = createStateReducer(initialState, {
  [events.removeOrganizationalUnitSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeOrganizationalUnit",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.removeOrganizationalUnitFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "removeOrganizationalUnit",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceRemoveOrganizationalUnitState };
